import { Box, Typography, Button } from '@mui/material';

interface ProgramTypeCardProps {
  title: string;
  description: string;
  onSelect: () => void;
}

export function ProgramTypeCard({ title, description, onSelect }: ProgramTypeCardProps) {
  return (
    <Box
      sx={{
        width: { xs: '100%', sm: 260, md: 280 },
        height: 300,
        p: 2,
        backgroundColor: '#151515',
        borderRadius: '6px',
        border: '1px solid #444',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2.5
      }}
    >
      <Typography fontSize={18} fontWeight={700} textAlign="center" color="#FDFDFD" lineHeight="30px">
        {title}
      </Typography>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          px: 1
        }}
      >
        <Typography fontSize={12} fontWeight={400} textAlign="center" color="#B6B6B6">
          {description}
        </Typography>
      </Box>

      <Button
        onClick={onSelect}
        sx={{
          height: 42,
          width: '100%',
          backgroundColor: '#565656',
          borderRadius: '6px',
          border: '1px solid #0F0F0F',
          color: '#FDFDFD',
          fontSize: 13,
          fontWeight: 500,
          textTransform: 'none',
          '&:hover': { backgroundColor: '#6b6b6b' }
        }}
      >
        Select
      </Button>
    </Box>
  );
}
